import { environment } from '@environments/environment';
import { AppInitService } from '@common_libraries/helpers/dynamic_configs/app-init.service';
export function init_app(appLoadService: AppInitService) {
  return () => appLoadService.init().then(() => {});
}

import { init } from '@sentry/angular-ivy';
import config from '../assets/config/live/config.json';

if (environment.production) {
  init({
    dsn: config.SentryDSN
  });
}

declare global {
  interface Window { Cypress: any; }
}


